import storage from 'local-storage-fallback';

export default {
  namespaced: true,

  state: {
    isDemoMode: storage.getItem('is_demo_mode'),
  },

  getters: {
    getIsDemoMode: state => {
      return state.isDemoMode;
    }
  },

  mutations: {
    SET_DEMO_MODE(state, mode) {
      state.isDemoMode = mode;
      if (mode) {
        storage.setItem('is_demo_mode', true);
      } else {
        storage.removeItem('is_demo_mode');
      }
    },
  },

  actions: {
    async CHANGE_DEMO_MODE(state, mode) {
      state.commit('SET_DEMO_MODE', mode);
    }
  }
};
